exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-1e5fc8e6]{text-align:right;font-weight:700;color:#e31837;margin-top:5px}", ""]);

// exports
